import React, { Component } from "react";
import WarningIconImage from "assets/Icon-Warning.svg";

export default class ApiErrorHandling extends Component {
  render() {
    const { error } = this.props;
    const { errorType, errors } = error;

    return (
      <div className="padding">
        <div className="flex-align-items-center" style={{ marginBottom: 0 }}>
          <img
            className="margin-right"
            src={WarningIconImage}
            alt="warning"
            width="16px"
          />
          <p className="title" style={{ margin: 0 }}>
            {errorType}
          </p>
        </div>
        {errors && errors.map((err, i) => <p key={i}>{err}</p>)}
      </div>
    );
  }
}
